<template>
  <div class="subscribe-container text-center">
    <div class="w-2/3 mx-auto">
      <h3 class="mb-4 fs-20 mt-0" v-if="title">{{title}}</h3>
      <div class="fs-16 mb-4" v-if="subTitle">{{subTitle}}</div>
    </div>
    <div class="email-group d-flex align-items-center justify-content-center">
      <validation-observer tag="div" class="cta-container sm:w-full" ref="valSubs">
        <form @submit.prevent="onBeforeSubmit" class="d-flex flex sm:w-full sm:block">
          <slot name="custom-field"></slot>

          <validation-provider
            tag='div'
            class="cta-container text-left"
            ref="Email"
            name="Email"
            rules="email|required"
            mode="lazy"
            v-slot="{ errors }"
          >
            <input
              class="input input-tall w-full block"
              :class="{ 'input--error': errors[0] }"
              placeholder="Your email"
              v-model="email" />
            <span class="fs-14 text-danger mt-1 error-alert">{{ errors[0] }}</span>
          </validation-provider>

          <button
            class="btn btn-primary ml-2 sm:ml-0 sm:mt-4"
            :disabled="isLoading"
          >
            Subscribe
            <div v-if="isLoading" class="zb-spin align-text-bottom inline-block"/>
          </button>
        </form>
      </validation-observer>
    </div>

    <zb-modal ref="thankModal" class="thank-you-modal text-left" :show-close-icon="false">
      <h3 slot="title" class="lh-150 fs-24 font-medium mb-2 download-title">Thanks for subscribing</h3>

      <template v-slot:default="{ modal }">
        <p class="mb-0 pb-24px fs-14 mb-6 lh-150">
          You’ll now be first to receive updates and exciting dive travel offers from ZuBlu.
        </p>

        <button
          type="button"
          class="btn btn-secondary input-tall md:w-full sm:w-full font-medium"
          @click="modal.hide"
        >
          Close
        </button>
      </template>
    </zb-modal>
  </div>
</template>
<script>
import debounce from 'lodash/debounce'
import {
  ValidationProvider,
  ValidationObserver,
  extend,
} from 'vee-validate'
import { required, email, min_value } from 'vee-validate/dist/rules'

import CustomButton from "../../components/core/Button";
import InputText from "../../components/core/Input";
import ZbModal from '../../components/core/ZbModal';

extend('email', {
  ...email,
  message: field => `Please enter a valid ${field}`
})
extend('min_value', min_value)
extend('required', {
  ...required,
  message: field => `Please enter your ${field}`
})

export default {
  name: "EmailSubscriber",
  components: {
    CustomButton,
    InputText,
    ZbModal,
    ValidationProvider,
    ValidationObserver,
  },
  props: [
    'title',
    'subTitle',
    'leadSource'
  ],
  data() {
    return {
      email: '',
      isLoading: false
    };
  },
  methods: {
    onBeforeSubmit: debounce(function() {
      if (this.isLoading === true) {
        return
      }

      const valid = this.$refs.valSubs.validate()
        .then(valid => {
          if (valid) {
            this.isLoading = true
            this.doSubmit()
          }
        })
    }, 500, {'leading': true}),

    doSubmit() {
      window.pushDataLayer("zublu_cta", {
        cta_type: "subscribe",
        cta_value: "newsletter"
      });

      $.ajax({
        method: 'POST',
        url: '/',
        data: {
          action: 'zuBlu/form/subscribe',
          [window.Craft.csrfTokenName]: window.Craft.csrfTokenValue,
          formData: {
            email: this.email,
            url: document.getElementById('page-url').value,
            Lead_Source: this.leadSource || ''
          }
        },
        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
      })
        .done(() => {
          this.isLoading = false
          this.$refs.thankModal.show()
        })
        .fail(e => {
          console.log(e)
        })
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/css/_form.scss";

.thank-you-modal .zb-modal-content {
  width: 400px !important;
}

.subscribe-container {
  .submit-button {
    margin-left: 8px;
  }

  .error-alert {
    margin-top: 4px;
  }

  .block {
    display: block;
  }

  .input {
    font-size: 16px;
  }

  .zb-spin {
    display: inline-block;
    vertical-align: text-bottom;
  }

  button[disabled], .btn-primary[disabled] {
    background-color: #EB7D00;
    border: none;
    color: white;
    opacity: 1;
  }

  .thank-you-modal {
    h3 {
      margin-top: 0;
    }
    button {
      width: 100%;
      padding: 10px 16px;
    }
  }

  .input-CTA {
    .input {
      padding: 8px 20px;
      font-size: 1rem !important;

      ::placeholder {
        font-size: inherit;
      }
    }
  }
}

@media only screen and ( min-width: 601px ) {
  .email-group input {
    width: 400px;
  }
  .error-alert {
    position: absolute;
  }
}

@media only screen and (min-width: 601px) and ( max-width: 1200px ) {
  .subscribe-container {
    padding: 64px 0;
    margin-top: 64px;
  }
}

@media only screen and (max-width: 600px) {
  .cta-container,
  .submit-button {
    width: 100%;
  }
  .subscribe-container {
    padding: 48px 0;
    margin-top: 48px;
  }

  form {
    flex-direction: column;
  }

  .submit-button {
    margin-top: 8px;
    margin-left: 0 !important;
  }
}
</style>
